import { emptySplitApi as api } from './emptyApi';
export const addTagTypes = ['routes'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      routesRouteBambiRouteCreate: build.mutation<
        RoutesRouteBambiRouteCreateApiResponse,
        RoutesRouteBambiRouteCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-bambi-route/`,
          method: 'POST',
          body: queryArg.applyRoutesRequest,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['routes'],
      }),
      routesRouteTemplateDataList: build.query<
        RoutesRouteTemplateDataListApiResponse,
        RoutesRouteTemplateDataListApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-template-data/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            active_after: queryArg.activeAfter,
            active_before: queryArg.activeBefore,
            active_on: queryArg.activeOn,
            days_of_week: queryArg.daysOfWeek,
            default_driver__in: queryArg.defaultDriverIn,
            name: queryArg.name,
            page: queryArg.page,
            page_size: queryArg.pageSize,
          },
        }),
        providesTags: ['routes'],
      }),
      routesRouteTemplateDataRetrieve: build.query<
        RoutesRouteTemplateDataRetrieveApiResponse,
        RoutesRouteTemplateDataRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-template-data/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['routes'],
      }),
      routesRouteTemplatesList: build.query<
        RoutesRouteTemplatesListApiResponse,
        RoutesRouteTemplatesListApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            active_after: queryArg.activeAfter,
            active_before: queryArg.activeBefore,
            active_on: queryArg.activeOn,
            days_of_week: queryArg.daysOfWeek,
            default_driver__in: queryArg.defaultDriverIn,
            name: queryArg.name,
            page: queryArg.page,
            page_size: queryArg.pageSize,
          },
        }),
        providesTags: ['routes'],
      }),
      routesRouteTemplatesCreate: build.mutation<
        RoutesRouteTemplatesCreateApiResponse,
        RoutesRouteTemplatesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/`,
          method: 'POST',
          body: queryArg.routeTemplate,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['routes'],
      }),
      routesRouteTemplatesRetrieve: build.query<
        RoutesRouteTemplatesRetrieveApiResponse,
        RoutesRouteTemplatesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['routes'],
      }),
      routesRouteTemplatesPartialUpdate: build.mutation<
        RoutesRouteTemplatesPartialUpdateApiResponse,
        RoutesRouteTemplatesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedRouteTemplate,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['routes'],
      }),
      routesRouteTemplatesDestroy: build.mutation<
        RoutesRouteTemplatesDestroyApiResponse,
        RoutesRouteTemplatesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/${queryArg.id}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['routes'],
      }),
      routesRouteTemplatesMultiloadList: build.query<
        RoutesRouteTemplatesMultiloadListApiResponse,
        RoutesRouteTemplatesMultiloadListApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/${queryArg.routeTemplateId}/multiload/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['routes'],
      }),
      routesRouteTemplatesMultiloadCreate: build.mutation<
        RoutesRouteTemplatesMultiloadCreateApiResponse,
        RoutesRouteTemplatesMultiloadCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/${queryArg.routeTemplateId}/multiload/`,
          method: 'POST',
          body: queryArg.routeMultiloadTemplate,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['routes'],
      }),
      routesRouteTemplatesMultiloadRetrieve: build.query<
        RoutesRouteTemplatesMultiloadRetrieveApiResponse,
        RoutesRouteTemplatesMultiloadRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/${queryArg.routeTemplateId}/multiload/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['routes'],
      }),
      routesRouteTemplatesMultiloadPartialUpdate: build.mutation<
        RoutesRouteTemplatesMultiloadPartialUpdateApiResponse,
        RoutesRouteTemplatesMultiloadPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/${queryArg.routeTemplateId}/multiload/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedRouteMultiloadTemplate,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['routes'],
      }),
      routesRouteTemplatesMultiloadDestroy: build.mutation<
        RoutesRouteTemplatesMultiloadDestroyApiResponse,
        RoutesRouteTemplatesMultiloadDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/${queryArg.routeTemplateId}/multiload/${queryArg.id}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['routes'],
      }),
      routesRouteTemplatesTripTemplatesList: build.query<
        RoutesRouteTemplatesTripTemplatesListApiResponse,
        RoutesRouteTemplatesTripTemplatesListApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/${queryArg.routeTemplateId}/trip-templates/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['routes'],
      }),
      routesRouteTemplatesTripTemplatesCreate: build.mutation<
        RoutesRouteTemplatesTripTemplatesCreateApiResponse,
        RoutesRouteTemplatesTripTemplatesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/${queryArg.routeTemplateId}/trip-templates/`,
          method: 'POST',
          body: queryArg.routeTripTemplate,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['routes'],
      }),
      routesRouteTemplatesTripTemplatesRetrieve: build.query<
        RoutesRouteTemplatesTripTemplatesRetrieveApiResponse,
        RoutesRouteTemplatesTripTemplatesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/${queryArg.routeTemplateId}/trip-templates/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['routes'],
      }),
      routesRouteTemplatesTripTemplatesPartialUpdate: build.mutation<
        RoutesRouteTemplatesTripTemplatesPartialUpdateApiResponse,
        RoutesRouteTemplatesTripTemplatesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/${queryArg.routeTemplateId}/trip-templates/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedRouteTripTemplate,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['routes'],
      }),
      routesRouteTemplatesTripTemplatesDestroy: build.mutation<
        RoutesRouteTemplatesTripTemplatesDestroyApiResponse,
        RoutesRouteTemplatesTripTemplatesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/route-templates/${queryArg.routeTemplateId}/trip-templates/${queryArg.id}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['routes'],
      }),
      routesRoutesList: build.query<
        RoutesRoutesListApiResponse,
        RoutesRoutesListApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/routes/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            page: queryArg.page,
            page_size: queryArg.pageSize,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
          },
        }),
        providesTags: ['routes'],
      }),
      routesRoutesRetrieve: build.query<
        RoutesRoutesRetrieveApiResponse,
        RoutesRoutesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/routes/routes/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['routes'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as bambiApi };
export type RoutesRouteBambiRouteCreateApiResponse =
  /** status 200  */ ApplyRoutesResults;
export type RoutesRouteBambiRouteCreateApiArg = {
  'Organization-ID'?: string;
  applyRoutesRequest: ApplyRoutesRequestWrite;
};
export type RoutesRouteTemplateDataListApiResponse =
  /** status 200  */ PaginatedRouteTemplateDataListRead;
export type RoutesRouteTemplateDataListApiArg = {
  'Organization-ID'?: string;
  activeAfter?: string;
  activeBefore?: string;
  activeOn?: string;
  daysOfWeek?: string;
  /** Multiple values may be separated by commas. */
  defaultDriverIn?: string[];
  name?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type RoutesRouteTemplateDataRetrieveApiResponse =
  /** status 200  */ RouteTemplateDataRead;
export type RoutesRouteTemplateDataRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this route template. */
  id: string;
};
export type RoutesRouteTemplatesListApiResponse =
  /** status 200  */ PaginatedRouteTemplateListRead;
export type RoutesRouteTemplatesListApiArg = {
  'Organization-ID'?: string;
  activeAfter?: string;
  activeBefore?: string;
  activeOn?: string;
  daysOfWeek?: string;
  /** Multiple values may be separated by commas. */
  defaultDriverIn?: string[];
  name?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type RoutesRouteTemplatesCreateApiResponse =
  /** status 201  */ RouteTemplateRead;
export type RoutesRouteTemplatesCreateApiArg = {
  'Organization-ID'?: string;
  routeTemplate: RouteTemplate;
};
export type RoutesRouteTemplatesRetrieveApiResponse =
  /** status 200  */ RouteTemplateRead;
export type RoutesRouteTemplatesRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this route template. */
  id: string;
};
export type RoutesRouteTemplatesPartialUpdateApiResponse =
  /** status 200  */ RouteTemplateRead;
export type RoutesRouteTemplatesPartialUpdateApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this route template. */
  id: string;
  patchedRouteTemplate: PatchedRouteTemplate;
};
export type RoutesRouteTemplatesDestroyApiResponse =
  /** status 204 No response body */ void;
export type RoutesRouteTemplatesDestroyApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this route template. */
  id: string;
};
export type RoutesRouteTemplatesMultiloadListApiResponse =
  /** status 200  */ PaginatedRouteMultiloadTemplateListRead;
export type RoutesRouteTemplatesMultiloadListApiArg = {
  'Organization-ID'?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  routeTemplateId: string;
};
export type RoutesRouteTemplatesMultiloadCreateApiResponse =
  /** status 201  */ RouteMultiloadTemplateRead;
export type RoutesRouteTemplatesMultiloadCreateApiArg = {
  'Organization-ID'?: string;
  routeTemplateId: string;
  routeMultiloadTemplate: RouteMultiloadTemplate;
};
export type RoutesRouteTemplatesMultiloadRetrieveApiResponse =
  /** status 200  */ RouteMultiloadTemplateRead;
export type RoutesRouteTemplatesMultiloadRetrieveApiArg = {
  'Organization-ID'?: string;
  id: string;
  routeTemplateId: string;
};
export type RoutesRouteTemplatesMultiloadPartialUpdateApiResponse =
  /** status 200  */ RouteMultiloadTemplateRead;
export type RoutesRouteTemplatesMultiloadPartialUpdateApiArg = {
  'Organization-ID'?: string;
  id: string;
  routeTemplateId: string;
  patchedRouteMultiloadTemplate: PatchedRouteMultiloadTemplate;
};
export type RoutesRouteTemplatesMultiloadDestroyApiResponse =
  /** status 204 No response body */ void;
export type RoutesRouteTemplatesMultiloadDestroyApiArg = {
  'Organization-ID'?: string;
  id: string;
  routeTemplateId: string;
};
export type RoutesRouteTemplatesTripTemplatesListApiResponse =
  /** status 200  */ PaginatedRouteTripTemplateListRead;
export type RoutesRouteTemplatesTripTemplatesListApiArg = {
  'Organization-ID'?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  routeTemplateId: string;
};
export type RoutesRouteTemplatesTripTemplatesCreateApiResponse =
  /** status 201  */ RouteTripTemplateRead;
export type RoutesRouteTemplatesTripTemplatesCreateApiArg = {
  'Organization-ID'?: string;
  routeTemplateId: string;
  routeTripTemplate: RouteTripTemplate;
};
export type RoutesRouteTemplatesTripTemplatesRetrieveApiResponse =
  /** status 200  */ RouteTripTemplateRead;
export type RoutesRouteTemplatesTripTemplatesRetrieveApiArg = {
  'Organization-ID'?: string;
  id: string;
  routeTemplateId: string;
};
export type RoutesRouteTemplatesTripTemplatesPartialUpdateApiResponse =
  /** status 200  */ RouteTripTemplateRead;
export type RoutesRouteTemplatesTripTemplatesPartialUpdateApiArg = {
  'Organization-ID'?: string;
  id: string;
  routeTemplateId: string;
  patchedRouteTripTemplate: PatchedRouteTripTemplate;
};
export type RoutesRouteTemplatesTripTemplatesDestroyApiResponse =
  /** status 204 No response body */ void;
export type RoutesRouteTemplatesTripTemplatesDestroyApiArg = {
  'Organization-ID'?: string;
  id: string;
  routeTemplateId: string;
};
export type RoutesRoutesListApiResponse =
  /** status 200  */ PaginatedRouteListRead;
export type RoutesRoutesListApiArg = {
  'Organization-ID'?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  rangeEnd?: string;
  rangeStart?: string;
};
export type RoutesRoutesRetrieveApiResponse = /** status 200  */ RouteRead;
export type RoutesRoutesRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this route. */
  id: string;
};
export type SuccessfulAssignmentDetails = {
  trip_id: string;
  route_template_id: string;
  route_trip_template_id: string;
};
export type SuccessfulAssignment = {
  assignment_id: string;
  details: SuccessfulAssignmentDetails[];
};
export type UnassignedTripResult = {
  trip_id: string;
  reason: string;
};
export type ApplyRoutesResults = {
  assigned_trips: SuccessfulAssignment[];
  unassigned_trips: UnassignedTripResult[];
  created_routes: string[];
};
export type ValidationErrorEnum = 'validation_error';
export type RoutesRouteBambiRouteCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type RoutesRouteBambiRouteCreateRouteTemplateIdsErrorComponent = {
  attr: 'route_template_ids';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type RoutesRouteBambiRouteCreateRouteTemplateIdsIndexErrorComponent = {
  attr: 'route_template_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type RoutesRouteBambiRouteCreateAssignmentIdsErrorComponent = {
  attr: 'assignment_ids';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type RoutesRouteBambiRouteCreateAssignmentIdsIndexErrorComponent = {
  attr: 'assignment_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type RoutesRouteBambiRouteCreateTripIdsErrorComponent = {
  attr: 'trip_ids';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type RoutesRouteBambiRouteCreateTripIdsIndexErrorComponent = {
  attr: 'trip_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type RoutesRouteBambiRouteCreateError =
  | ({
      attr: 'non_field_errors';
    } & RoutesRouteBambiRouteCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'route_template_ids';
    } & RoutesRouteBambiRouteCreateRouteTemplateIdsErrorComponent)
  | ({
      attr: 'route_template_ids.INDEX';
    } & RoutesRouteBambiRouteCreateRouteTemplateIdsIndexErrorComponent)
  | ({
      attr: 'assignment_ids';
    } & RoutesRouteBambiRouteCreateAssignmentIdsErrorComponent)
  | ({
      attr: 'assignment_ids.INDEX';
    } & RoutesRouteBambiRouteCreateAssignmentIdsIndexErrorComponent)
  | ({
      attr: 'trip_ids';
    } & RoutesRouteBambiRouteCreateTripIdsErrorComponent)
  | ({
      attr: 'trip_ids.INDEX';
    } & RoutesRouteBambiRouteCreateTripIdsIndexErrorComponent);
export type RoutesRouteBambiRouteCreateValidationError = {
  type: ValidationErrorEnum;
  errors: RoutesRouteBambiRouteCreateError[];
};
export type ClientErrorEnum = 'client_error';
export type ParseErrorCodeEnum = 'parse_error';
export type ParseError = {
  code: ParseErrorCodeEnum;
  detail: string;
  attr: string | null;
};
export type ParseErrorResponse = {
  type: ClientErrorEnum;
  errors: ParseError[];
};
export type RoutesRouteBambiRouteCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & RoutesRouteBambiRouteCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type ErrorCode403Enum = 'permission_denied';
export type Error403 = {
  code: ErrorCode403Enum;
  detail: string;
  attr: string | null;
};
export type ErrorResponse403 = {
  type: ClientErrorEnum;
  errors: Error403[];
};
export type ApplyRoutesRequest = {};
export type ApplyRoutesRequestWrite = {
  route_template_ids: string[];
  assignment_ids: string[];
  trip_ids: string[];
};
export type DaysOfWeekEnum =
  | 'mon'
  | 'tue'
  | 'wed'
  | 'thu'
  | 'fri'
  | 'sat'
  | 'sun';
export type StairEquipmentEnum = 'ramp' | 'stair-chair';
export type BlankEnum = '';
export type TripLocationDetail = {
  address_details?: string;
  /** The number of stairs at this location */
  num_stairs?: number;
  /** Stair equipment required for this location */
  stair_equipment?: StairEquipmentEnum | BlankEnum;
  /** Name of contact for this location, if not passenger */
  contact_name?: string;
  /** Phone number of contact for this location, if not passenger */
  contact_phone_number?: string | null;
  /** Notes visible to the driver for this location */
  driver_notes?: string;
  place_id: string;
};
export type PurposeEnum = 'pickup' | 'dropoff';
export type TripLocationDetailRead = {
  id: string;
  /** Purpose of this location, pickup, dropoff, etc. */
  purpose: PurposeEnum;
  address: string;
  address_details?: string;
  latitude: number;
  longitude: number;
  /** The number of stairs at this location */
  num_stairs?: number;
  /** Stair equipment required for this location */
  stair_equipment?: StairEquipmentEnum | BlankEnum;
  /** Name of contact for this location, if not passenger */
  contact_name?: string;
  /** Phone number of contact for this location, if not passenger */
  contact_phone_number?: string | null;
  /** Notes visible to the driver for this location */
  driver_notes?: string;
  place_id: string;
};
export type SpaceTypeEnum =
  | 'wheelchair'
  | 'wheelchair xl'
  | 'broda chair'
  | 'geri chair'
  | 'stretcher'
  | 'ambulatory';
export type RouteTripTemplate = {
  id?: string;
  passenger_id: string;
  scheduled_pickup_time: string;
  pickup: TripLocationDetail;
  dropoff: TripLocationDetail;
  /** The type of space in the vehicle this passenger will need */
  space_type: SpaceTypeEnum;
  /** How many additional people will be accompanying the primary passenger */
  num_accompanying_passengers?: number;
};
export type RouteTripTemplateRead = {
  id?: string;
  route_template_id: string;
  passenger_id: string;
  scheduled_pickup_time: string;
  pickup: TripLocationDetailRead;
  dropoff: TripLocationDetailRead;
  /** The type of space in the vehicle this passenger will need */
  space_type: SpaceTypeEnum;
  /** How many additional people will be accompanying the primary passenger */
  num_accompanying_passengers?: number;
};
export type RouteTemplateData = {
  name: string;
  start_time: string;
  end_time: string;
  notes?: string;
  /** Days the route is available; empty implies all days. */
  days_of_week?: DaysOfWeekEnum[];
  /** if Run Bambi Run is allowed to assign non-route trips within the route */
  allow_rbr_trips?: boolean;
  range_start?: string | null;
  range_end?: string | null;
  trip_templates: RouteTripTemplate[];
  deleted_at?: string | null;
};
export type RouteTemplateDataRead = {
  id: string;
  organization_id: string;
  name: string;
  default_driver_id: string;
  default_driver_name: string;
  start_time: string;
  end_time: string;
  notes?: string;
  /** Days the route is available; empty implies all days. */
  days_of_week?: DaysOfWeekEnum[];
  /** if Run Bambi Run is allowed to assign non-route trips within the route */
  allow_rbr_trips?: boolean;
  range_start?: string | null;
  range_end?: string | null;
  trip_templates: RouteTripTemplateRead[];
  created_at: string;
  updated_at: string;
  deleted_at?: string | null;
};
export type PaginatedRouteTemplateDataList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: RouteTemplateData[];
};
export type PaginatedRouteTemplateDataListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: RouteTemplateDataRead[];
};
export type RoutesRouteTemplateDataListNameErrorComponent = {
  attr: 'name';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type RoutesRouteTemplateDataListDaysOfWeekErrorComponent = {
  attr: 'days_of_week';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type RoutesRouteTemplateDataListActiveOnErrorComponent = {
  attr: 'active_on';
  code: 'invalid';
  detail: string;
};
export type RoutesRouteTemplateDataListActiveAfterErrorComponent = {
  attr: 'active_after';
  code: 'invalid';
  detail: string;
};
export type RoutesRouteTemplateDataListActiveBeforeErrorComponent = {
  attr: 'active_before';
  code: 'invalid';
  detail: string;
};
export type RoutesRouteTemplateDataListError =
  | ({
      attr: 'name';
    } & RoutesRouteTemplateDataListNameErrorComponent)
  | ({
      attr: 'days_of_week';
    } & RoutesRouteTemplateDataListDaysOfWeekErrorComponent)
  | ({
      attr: 'active_on';
    } & RoutesRouteTemplateDataListActiveOnErrorComponent)
  | ({
      attr: 'active_after';
    } & RoutesRouteTemplateDataListActiveAfterErrorComponent)
  | ({
      attr: 'active_before';
    } & RoutesRouteTemplateDataListActiveBeforeErrorComponent);
export type RoutesRouteTemplateDataListValidationError = {
  type: ValidationErrorEnum;
  errors: RoutesRouteTemplateDataListError[];
};
export type RoutesRouteTemplateDataListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & RoutesRouteTemplateDataListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type ErrorCode404Enum = 'not_found';
export type Error404 = {
  code: ErrorCode404Enum;
  detail: string;
  attr: string | null;
};
export type ErrorResponse404 = {
  type: ClientErrorEnum;
  errors: Error404[];
};
export type RoutesRouteTemplateDataRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type RouteTemplate = {
  name: string;
  default_driver_id: string;
  start_time: string;
  end_time: string;
  notes?: string;
  /** Days the route is available; empty implies all days. */
  days_of_week?: DaysOfWeekEnum[];
  /** if Run Bambi Run is allowed to assign non-route trips within the route */
  allow_rbr_trips?: boolean;
  range_start?: string | null;
  range_end?: string | null;
  deleted_at?: string | null;
};
export type RouteTemplateRead = {
  id: string;
  organization_id: string;
  name: string;
  default_driver_id: string;
  default_driver_name: string;
  start_time: string;
  end_time: string;
  notes?: string;
  /** Days the route is available; empty implies all days. */
  days_of_week?: DaysOfWeekEnum[];
  /** if Run Bambi Run is allowed to assign non-route trips within the route */
  allow_rbr_trips?: boolean;
  range_start?: string | null;
  range_end?: string | null;
  trip_template_count: number;
  created_at: string;
  updated_at: string;
  deleted_at?: string | null;
};
export type PaginatedRouteTemplateList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: RouteTemplate[];
};
export type PaginatedRouteTemplateListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: RouteTemplateRead[];
};
export type RoutesRouteTemplatesListNameErrorComponent = {
  attr: 'name';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type RoutesRouteTemplatesListDaysOfWeekErrorComponent = {
  attr: 'days_of_week';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type RoutesRouteTemplatesListActiveOnErrorComponent = {
  attr: 'active_on';
  code: 'invalid';
  detail: string;
};
export type RoutesRouteTemplatesListActiveAfterErrorComponent = {
  attr: 'active_after';
  code: 'invalid';
  detail: string;
};
export type RoutesRouteTemplatesListActiveBeforeErrorComponent = {
  attr: 'active_before';
  code: 'invalid';
  detail: string;
};
export type RoutesRouteTemplatesListError =
  | ({
      attr: 'name';
    } & RoutesRouteTemplatesListNameErrorComponent)
  | ({
      attr: 'days_of_week';
    } & RoutesRouteTemplatesListDaysOfWeekErrorComponent)
  | ({
      attr: 'active_on';
    } & RoutesRouteTemplatesListActiveOnErrorComponent)
  | ({
      attr: 'active_after';
    } & RoutesRouteTemplatesListActiveAfterErrorComponent)
  | ({
      attr: 'active_before';
    } & RoutesRouteTemplatesListActiveBeforeErrorComponent);
export type RoutesRouteTemplatesListValidationError = {
  type: ValidationErrorEnum;
  errors: RoutesRouteTemplatesListError[];
};
export type RoutesRouteTemplatesListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & RoutesRouteTemplatesListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type RoutesRouteTemplatesCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type RoutesRouteTemplatesCreateNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type RoutesRouteTemplatesCreateDefaultDriverIdErrorComponent = {
  attr: 'default_driver_id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type RoutesRouteTemplatesCreateStartTimeErrorComponent = {
  attr: 'start_time';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type RoutesRouteTemplatesCreateEndTimeErrorComponent = {
  attr: 'end_time';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type RoutesRouteTemplatesCreateNotesErrorComponent = {
  attr: 'notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type RoutesRouteTemplatesCreateDaysOfWeekErrorComponent = {
  attr: 'days_of_week';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type RoutesRouteTemplatesCreateDaysOfWeekIndexErrorComponent = {
  attr: 'days_of_week.INDEX';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type RoutesRouteTemplatesCreateAllowRbrTripsErrorComponent = {
  attr: 'allow_rbr_trips';
  code: 'invalid' | 'null';
  detail: string;
};
export type RoutesRouteTemplatesCreateRangeStartErrorComponent = {
  attr: 'range_start';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type RoutesRouteTemplatesCreateRangeEndErrorComponent = {
  attr: 'range_end';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type RoutesRouteTemplatesCreateDeletedAtErrorComponent = {
  attr: 'deleted_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type RoutesRouteTemplatesCreateError =
  | ({
      attr: 'non_field_errors';
    } & RoutesRouteTemplatesCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & RoutesRouteTemplatesCreateNameErrorComponent)
  | ({
      attr: 'default_driver_id';
    } & RoutesRouteTemplatesCreateDefaultDriverIdErrorComponent)
  | ({
      attr: 'start_time';
    } & RoutesRouteTemplatesCreateStartTimeErrorComponent)
  | ({
      attr: 'end_time';
    } & RoutesRouteTemplatesCreateEndTimeErrorComponent)
  | ({
      attr: 'notes';
    } & RoutesRouteTemplatesCreateNotesErrorComponent)
  | ({
      attr: 'days_of_week';
    } & RoutesRouteTemplatesCreateDaysOfWeekErrorComponent)
  | ({
      attr: 'days_of_week.INDEX';
    } & RoutesRouteTemplatesCreateDaysOfWeekIndexErrorComponent)
  | ({
      attr: 'allow_rbr_trips';
    } & RoutesRouteTemplatesCreateAllowRbrTripsErrorComponent)
  | ({
      attr: 'range_start';
    } & RoutesRouteTemplatesCreateRangeStartErrorComponent)
  | ({
      attr: 'range_end';
    } & RoutesRouteTemplatesCreateRangeEndErrorComponent)
  | ({
      attr: 'deleted_at';
    } & RoutesRouteTemplatesCreateDeletedAtErrorComponent);
export type RoutesRouteTemplatesCreateValidationError = {
  type: ValidationErrorEnum;
  errors: RoutesRouteTemplatesCreateError[];
};
export type RoutesRouteTemplatesCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & RoutesRouteTemplatesCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type RoutesRouteTemplatesRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type RoutesRouteTemplatesPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type RoutesRouteTemplatesPartialUpdateNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type RoutesRouteTemplatesPartialUpdateDefaultDriverIdErrorComponent = {
  attr: 'default_driver_id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type RoutesRouteTemplatesPartialUpdateStartTimeErrorComponent = {
  attr: 'start_time';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type RoutesRouteTemplatesPartialUpdateEndTimeErrorComponent = {
  attr: 'end_time';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type RoutesRouteTemplatesPartialUpdateNotesErrorComponent = {
  attr: 'notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type RoutesRouteTemplatesPartialUpdateDaysOfWeekErrorComponent = {
  attr: 'days_of_week';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type RoutesRouteTemplatesPartialUpdateDaysOfWeekIndexErrorComponent = {
  attr: 'days_of_week.INDEX';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type RoutesRouteTemplatesPartialUpdateAllowRbrTripsErrorComponent = {
  attr: 'allow_rbr_trips';
  code: 'invalid' | 'null';
  detail: string;
};
export type RoutesRouteTemplatesPartialUpdateRangeStartErrorComponent = {
  attr: 'range_start';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type RoutesRouteTemplatesPartialUpdateRangeEndErrorComponent = {
  attr: 'range_end';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type RoutesRouteTemplatesPartialUpdateDeletedAtErrorComponent = {
  attr: 'deleted_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type RoutesRouteTemplatesPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & RoutesRouteTemplatesPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & RoutesRouteTemplatesPartialUpdateNameErrorComponent)
  | ({
      attr: 'default_driver_id';
    } & RoutesRouteTemplatesPartialUpdateDefaultDriverIdErrorComponent)
  | ({
      attr: 'start_time';
    } & RoutesRouteTemplatesPartialUpdateStartTimeErrorComponent)
  | ({
      attr: 'end_time';
    } & RoutesRouteTemplatesPartialUpdateEndTimeErrorComponent)
  | ({
      attr: 'notes';
    } & RoutesRouteTemplatesPartialUpdateNotesErrorComponent)
  | ({
      attr: 'days_of_week';
    } & RoutesRouteTemplatesPartialUpdateDaysOfWeekErrorComponent)
  | ({
      attr: 'days_of_week.INDEX';
    } & RoutesRouteTemplatesPartialUpdateDaysOfWeekIndexErrorComponent)
  | ({
      attr: 'allow_rbr_trips';
    } & RoutesRouteTemplatesPartialUpdateAllowRbrTripsErrorComponent)
  | ({
      attr: 'range_start';
    } & RoutesRouteTemplatesPartialUpdateRangeStartErrorComponent)
  | ({
      attr: 'range_end';
    } & RoutesRouteTemplatesPartialUpdateRangeEndErrorComponent)
  | ({
      attr: 'deleted_at';
    } & RoutesRouteTemplatesPartialUpdateDeletedAtErrorComponent);
export type RoutesRouteTemplatesPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: RoutesRouteTemplatesPartialUpdateError[];
};
export type RoutesRouteTemplatesPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & RoutesRouteTemplatesPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedRouteTemplate = {
  name?: string;
  default_driver_id?: string;
  start_time?: string;
  end_time?: string;
  notes?: string;
  /** Days the route is available; empty implies all days. */
  days_of_week?: DaysOfWeekEnum[];
  /** if Run Bambi Run is allowed to assign non-route trips within the route */
  allow_rbr_trips?: boolean;
  range_start?: string | null;
  range_end?: string | null;
  deleted_at?: string | null;
};
export type PatchedRouteTemplateRead = {
  id?: string;
  organization_id?: string;
  name?: string;
  default_driver_id?: string;
  default_driver_name?: string;
  start_time?: string;
  end_time?: string;
  notes?: string;
  /** Days the route is available; empty implies all days. */
  days_of_week?: DaysOfWeekEnum[];
  /** if Run Bambi Run is allowed to assign non-route trips within the route */
  allow_rbr_trips?: boolean;
  range_start?: string | null;
  range_end?: string | null;
  trip_template_count?: number;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string | null;
};
export type RoutesRouteTemplatesDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type OrderedMultiloadTripLocationDetailTemplate = {
  trip_location_detail_id: string;
  order: number;
};
export type RouteMultiloadTemplate = {
  template_trip_location_details: OrderedMultiloadTripLocationDetailTemplate[];
  deleted_at?: string | null;
};
export type RouteMultiloadTemplateRead = {
  id: string;
  organization_id: string;
  route_template_id: string;
  template_trip_location_details: OrderedMultiloadTripLocationDetailTemplate[];
  updated_at: string;
  created_at: string;
  deleted_at?: string | null;
};
export type PaginatedRouteMultiloadTemplateList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: RouteMultiloadTemplate[];
};
export type PaginatedRouteMultiloadTemplateListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: RouteMultiloadTemplateRead[];
};
export type RoutesRouteTemplatesMultiloadListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type RoutesRouteTemplatesMultiloadCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type RoutesRouteTemplatesMultiloadCreateTemplateTripLocationDetailsNonFieldErrorsErrorComponent =
  {
    attr: 'template_trip_location_details.non_field_errors';
    code: 'not_a_list' | 'null' | 'required';
    detail: string;
  };
export type RoutesRouteTemplatesMultiloadCreateTemplateTripLocationDetailsIndexNonFieldErrorsErrorComponent =
  {
    attr: 'template_trip_location_details.INDEX.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type RoutesRouteTemplatesMultiloadCreateTemplateTripLocationDetailsIndexTripLocationDetailIdErrorComponent =
  {
    attr: 'template_trip_location_details.INDEX.trip_location_detail_id';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type RoutesRouteTemplatesMultiloadCreateTemplateTripLocationDetailsIndexOrderErrorComponent =
  {
    attr: 'template_trip_location_details.INDEX.order';
    code:
      | 'invalid'
      | 'max_string_length'
      | 'max_value'
      | 'min_value'
      | 'null'
      | 'required';
    detail: string;
  };
export type RoutesRouteTemplatesMultiloadCreateDeletedAtErrorComponent = {
  attr: 'deleted_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type RoutesRouteTemplatesMultiloadCreateError =
  | ({
      attr: 'non_field_errors';
    } & RoutesRouteTemplatesMultiloadCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'template_trip_location_details.non_field_errors';
    } & RoutesRouteTemplatesMultiloadCreateTemplateTripLocationDetailsNonFieldErrorsErrorComponent)
  | ({
      attr: 'template_trip_location_details.INDEX.non_field_errors';
    } & RoutesRouteTemplatesMultiloadCreateTemplateTripLocationDetailsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'template_trip_location_details.INDEX.trip_location_detail_id';
    } & RoutesRouteTemplatesMultiloadCreateTemplateTripLocationDetailsIndexTripLocationDetailIdErrorComponent)
  | ({
      attr: 'template_trip_location_details.INDEX.order';
    } & RoutesRouteTemplatesMultiloadCreateTemplateTripLocationDetailsIndexOrderErrorComponent)
  | ({
      attr: 'deleted_at';
    } & RoutesRouteTemplatesMultiloadCreateDeletedAtErrorComponent);
export type RoutesRouteTemplatesMultiloadCreateValidationError = {
  type: ValidationErrorEnum;
  errors: RoutesRouteTemplatesMultiloadCreateError[];
};
export type RoutesRouteTemplatesMultiloadCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & RoutesRouteTemplatesMultiloadCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type RoutesRouteTemplatesMultiloadRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type RoutesRouteTemplatesMultiloadPartialUpdateNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type RoutesRouteTemplatesMultiloadPartialUpdateTemplateTripLocationDetailsNonFieldErrorsErrorComponent =
  {
    attr: 'template_trip_location_details.non_field_errors';
    code: 'not_a_list' | 'null' | 'required';
    detail: string;
  };
export type RoutesRouteTemplatesMultiloadPartialUpdateTemplateTripLocationDetailsIndexNonFieldErrorsErrorComponent =
  {
    attr: 'template_trip_location_details.INDEX.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type RoutesRouteTemplatesMultiloadPartialUpdateTemplateTripLocationDetailsIndexTripLocationDetailIdErrorComponent =
  {
    attr: 'template_trip_location_details.INDEX.trip_location_detail_id';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type RoutesRouteTemplatesMultiloadPartialUpdateTemplateTripLocationDetailsIndexOrderErrorComponent =
  {
    attr: 'template_trip_location_details.INDEX.order';
    code:
      | 'invalid'
      | 'max_string_length'
      | 'max_value'
      | 'min_value'
      | 'null'
      | 'required';
    detail: string;
  };
export type RoutesRouteTemplatesMultiloadPartialUpdateDeletedAtErrorComponent =
  {
    attr: 'deleted_at';
    code: 'date' | 'invalid' | 'make_aware' | 'overflow';
    detail: string;
  };
export type RoutesRouteTemplatesMultiloadPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & RoutesRouteTemplatesMultiloadPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'template_trip_location_details.non_field_errors';
    } & RoutesRouteTemplatesMultiloadPartialUpdateTemplateTripLocationDetailsNonFieldErrorsErrorComponent)
  | ({
      attr: 'template_trip_location_details.INDEX.non_field_errors';
    } & RoutesRouteTemplatesMultiloadPartialUpdateTemplateTripLocationDetailsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'template_trip_location_details.INDEX.trip_location_detail_id';
    } & RoutesRouteTemplatesMultiloadPartialUpdateTemplateTripLocationDetailsIndexTripLocationDetailIdErrorComponent)
  | ({
      attr: 'template_trip_location_details.INDEX.order';
    } & RoutesRouteTemplatesMultiloadPartialUpdateTemplateTripLocationDetailsIndexOrderErrorComponent)
  | ({
      attr: 'deleted_at';
    } & RoutesRouteTemplatesMultiloadPartialUpdateDeletedAtErrorComponent);
export type RoutesRouteTemplatesMultiloadPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: RoutesRouteTemplatesMultiloadPartialUpdateError[];
};
export type RoutesRouteTemplatesMultiloadPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & RoutesRouteTemplatesMultiloadPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedRouteMultiloadTemplate = {
  template_trip_location_details?: OrderedMultiloadTripLocationDetailTemplate[];
  deleted_at?: string | null;
};
export type PatchedRouteMultiloadTemplateRead = {
  id?: string;
  organization_id?: string;
  route_template_id?: string;
  template_trip_location_details?: OrderedMultiloadTripLocationDetailTemplate[];
  updated_at?: string;
  created_at?: string;
  deleted_at?: string | null;
};
export type RoutesRouteTemplatesMultiloadDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PaginatedRouteTripTemplateList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: RouteTripTemplate[];
};
export type PaginatedRouteTripTemplateListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: RouteTripTemplateRead[];
};
export type RoutesRouteTemplatesTripTemplatesListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type RoutesRouteTemplatesTripTemplatesCreateNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesCreateIdErrorComponent = {
  attr: 'id';
  code: 'invalid' | 'null' | 'unique';
  detail: string;
};
export type RoutesRouteTemplatesTripTemplatesCreatePassengerIdErrorComponent = {
  attr: 'passenger_id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type RoutesRouteTemplatesTripTemplatesCreateScheduledPickupTimeErrorComponent =
  {
    attr: 'scheduled_pickup_time';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesCreatePickupNonFieldErrorsErrorComponent =
  {
    attr: 'pickup.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesCreatePickupAddressDetailsErrorComponent =
  {
    attr: 'pickup.address_details';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesCreatePickupNumStairsErrorComponent =
  {
    attr: 'pickup.num_stairs';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesCreatePickupStairEquipmentErrorComponent =
  {
    attr: 'pickup.stair_equipment';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesCreatePickupContactNameErrorComponent =
  {
    attr: 'pickup.contact_name';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesCreatePickupContactPhoneNumberErrorComponent =
  {
    attr: 'pickup.contact_phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesCreatePickupDriverNotesErrorComponent =
  {
    attr: 'pickup.driver_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesCreatePickupPlaceIdErrorComponent =
  {
    attr: 'pickup.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesCreateDropoffNonFieldErrorsErrorComponent =
  {
    attr: 'dropoff.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesCreateDropoffAddressDetailsErrorComponent =
  {
    attr: 'dropoff.address_details';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesCreateDropoffNumStairsErrorComponent =
  {
    attr: 'dropoff.num_stairs';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesCreateDropoffStairEquipmentErrorComponent =
  {
    attr: 'dropoff.stair_equipment';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesCreateDropoffContactNameErrorComponent =
  {
    attr: 'dropoff.contact_name';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesCreateDropoffContactPhoneNumberErrorComponent =
  {
    attr: 'dropoff.contact_phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesCreateDropoffDriverNotesErrorComponent =
  {
    attr: 'dropoff.driver_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesCreateDropoffPlaceIdErrorComponent =
  {
    attr: 'dropoff.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesCreateSpaceTypeErrorComponent = {
  attr: 'space_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type RoutesRouteTemplatesTripTemplatesCreateNumAccompanyingPassengersErrorComponent =
  {
    attr: 'num_accompanying_passengers';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesCreateError =
  | ({
      attr: 'non_field_errors';
    } & RoutesRouteTemplatesTripTemplatesCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'id';
    } & RoutesRouteTemplatesTripTemplatesCreateIdErrorComponent)
  | ({
      attr: 'passenger_id';
    } & RoutesRouteTemplatesTripTemplatesCreatePassengerIdErrorComponent)
  | ({
      attr: 'scheduled_pickup_time';
    } & RoutesRouteTemplatesTripTemplatesCreateScheduledPickupTimeErrorComponent)
  | ({
      attr: 'pickup.non_field_errors';
    } & RoutesRouteTemplatesTripTemplatesCreatePickupNonFieldErrorsErrorComponent)
  | ({
      attr: 'pickup.address_details';
    } & RoutesRouteTemplatesTripTemplatesCreatePickupAddressDetailsErrorComponent)
  | ({
      attr: 'pickup.num_stairs';
    } & RoutesRouteTemplatesTripTemplatesCreatePickupNumStairsErrorComponent)
  | ({
      attr: 'pickup.stair_equipment';
    } & RoutesRouteTemplatesTripTemplatesCreatePickupStairEquipmentErrorComponent)
  | ({
      attr: 'pickup.contact_name';
    } & RoutesRouteTemplatesTripTemplatesCreatePickupContactNameErrorComponent)
  | ({
      attr: 'pickup.contact_phone_number';
    } & RoutesRouteTemplatesTripTemplatesCreatePickupContactPhoneNumberErrorComponent)
  | ({
      attr: 'pickup.driver_notes';
    } & RoutesRouteTemplatesTripTemplatesCreatePickupDriverNotesErrorComponent)
  | ({
      attr: 'pickup.place_id';
    } & RoutesRouteTemplatesTripTemplatesCreatePickupPlaceIdErrorComponent)
  | ({
      attr: 'dropoff.non_field_errors';
    } & RoutesRouteTemplatesTripTemplatesCreateDropoffNonFieldErrorsErrorComponent)
  | ({
      attr: 'dropoff.address_details';
    } & RoutesRouteTemplatesTripTemplatesCreateDropoffAddressDetailsErrorComponent)
  | ({
      attr: 'dropoff.num_stairs';
    } & RoutesRouteTemplatesTripTemplatesCreateDropoffNumStairsErrorComponent)
  | ({
      attr: 'dropoff.stair_equipment';
    } & RoutesRouteTemplatesTripTemplatesCreateDropoffStairEquipmentErrorComponent)
  | ({
      attr: 'dropoff.contact_name';
    } & RoutesRouteTemplatesTripTemplatesCreateDropoffContactNameErrorComponent)
  | ({
      attr: 'dropoff.contact_phone_number';
    } & RoutesRouteTemplatesTripTemplatesCreateDropoffContactPhoneNumberErrorComponent)
  | ({
      attr: 'dropoff.driver_notes';
    } & RoutesRouteTemplatesTripTemplatesCreateDropoffDriverNotesErrorComponent)
  | ({
      attr: 'dropoff.place_id';
    } & RoutesRouteTemplatesTripTemplatesCreateDropoffPlaceIdErrorComponent)
  | ({
      attr: 'space_type';
    } & RoutesRouteTemplatesTripTemplatesCreateSpaceTypeErrorComponent)
  | ({
      attr: 'num_accompanying_passengers';
    } & RoutesRouteTemplatesTripTemplatesCreateNumAccompanyingPassengersErrorComponent);
export type RoutesRouteTemplatesTripTemplatesCreateValidationError = {
  type: ValidationErrorEnum;
  errors: RoutesRouteTemplatesTripTemplatesCreateError[];
};
export type RoutesRouteTemplatesTripTemplatesCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & RoutesRouteTemplatesTripTemplatesCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type RoutesRouteTemplatesTripTemplatesRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type RoutesRouteTemplatesTripTemplatesPartialUpdateNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesPartialUpdateIdErrorComponent = {
  attr: 'id';
  code: 'invalid' | 'null' | 'unique';
  detail: string;
};
export type RoutesRouteTemplatesTripTemplatesPartialUpdatePassengerIdErrorComponent =
  {
    attr: 'passenger_id';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesPartialUpdateScheduledPickupTimeErrorComponent =
  {
    attr: 'scheduled_pickup_time';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesPartialUpdatePickupNonFieldErrorsErrorComponent =
  {
    attr: 'pickup.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesPartialUpdatePickupAddressDetailsErrorComponent =
  {
    attr: 'pickup.address_details';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesPartialUpdatePickupNumStairsErrorComponent =
  {
    attr: 'pickup.num_stairs';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesPartialUpdatePickupStairEquipmentErrorComponent =
  {
    attr: 'pickup.stair_equipment';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesPartialUpdatePickupContactNameErrorComponent =
  {
    attr: 'pickup.contact_name';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesPartialUpdatePickupContactPhoneNumberErrorComponent =
  {
    attr: 'pickup.contact_phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesPartialUpdatePickupDriverNotesErrorComponent =
  {
    attr: 'pickup.driver_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesPartialUpdatePickupPlaceIdErrorComponent =
  {
    attr: 'pickup.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesPartialUpdateDropoffNonFieldErrorsErrorComponent =
  {
    attr: 'dropoff.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesPartialUpdateDropoffAddressDetailsErrorComponent =
  {
    attr: 'dropoff.address_details';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesPartialUpdateDropoffNumStairsErrorComponent =
  {
    attr: 'dropoff.num_stairs';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesPartialUpdateDropoffStairEquipmentErrorComponent =
  {
    attr: 'dropoff.stair_equipment';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesPartialUpdateDropoffContactNameErrorComponent =
  {
    attr: 'dropoff.contact_name';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesPartialUpdateDropoffContactPhoneNumberErrorComponent =
  {
    attr: 'dropoff.contact_phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesPartialUpdateDropoffDriverNotesErrorComponent =
  {
    attr: 'dropoff.driver_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesPartialUpdateDropoffPlaceIdErrorComponent =
  {
    attr: 'dropoff.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesPartialUpdateSpaceTypeErrorComponent =
  {
    attr: 'space_type';
    code: 'invalid_choice' | 'null' | 'required';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesPartialUpdateNumAccompanyingPassengersErrorComponent =
  {
    attr: 'num_accompanying_passengers';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type RoutesRouteTemplatesTripTemplatesPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & RoutesRouteTemplatesTripTemplatesPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'id';
    } & RoutesRouteTemplatesTripTemplatesPartialUpdateIdErrorComponent)
  | ({
      attr: 'passenger_id';
    } & RoutesRouteTemplatesTripTemplatesPartialUpdatePassengerIdErrorComponent)
  | ({
      attr: 'scheduled_pickup_time';
    } & RoutesRouteTemplatesTripTemplatesPartialUpdateScheduledPickupTimeErrorComponent)
  | ({
      attr: 'pickup.non_field_errors';
    } & RoutesRouteTemplatesTripTemplatesPartialUpdatePickupNonFieldErrorsErrorComponent)
  | ({
      attr: 'pickup.address_details';
    } & RoutesRouteTemplatesTripTemplatesPartialUpdatePickupAddressDetailsErrorComponent)
  | ({
      attr: 'pickup.num_stairs';
    } & RoutesRouteTemplatesTripTemplatesPartialUpdatePickupNumStairsErrorComponent)
  | ({
      attr: 'pickup.stair_equipment';
    } & RoutesRouteTemplatesTripTemplatesPartialUpdatePickupStairEquipmentErrorComponent)
  | ({
      attr: 'pickup.contact_name';
    } & RoutesRouteTemplatesTripTemplatesPartialUpdatePickupContactNameErrorComponent)
  | ({
      attr: 'pickup.contact_phone_number';
    } & RoutesRouteTemplatesTripTemplatesPartialUpdatePickupContactPhoneNumberErrorComponent)
  | ({
      attr: 'pickup.driver_notes';
    } & RoutesRouteTemplatesTripTemplatesPartialUpdatePickupDriverNotesErrorComponent)
  | ({
      attr: 'pickup.place_id';
    } & RoutesRouteTemplatesTripTemplatesPartialUpdatePickupPlaceIdErrorComponent)
  | ({
      attr: 'dropoff.non_field_errors';
    } & RoutesRouteTemplatesTripTemplatesPartialUpdateDropoffNonFieldErrorsErrorComponent)
  | ({
      attr: 'dropoff.address_details';
    } & RoutesRouteTemplatesTripTemplatesPartialUpdateDropoffAddressDetailsErrorComponent)
  | ({
      attr: 'dropoff.num_stairs';
    } & RoutesRouteTemplatesTripTemplatesPartialUpdateDropoffNumStairsErrorComponent)
  | ({
      attr: 'dropoff.stair_equipment';
    } & RoutesRouteTemplatesTripTemplatesPartialUpdateDropoffStairEquipmentErrorComponent)
  | ({
      attr: 'dropoff.contact_name';
    } & RoutesRouteTemplatesTripTemplatesPartialUpdateDropoffContactNameErrorComponent)
  | ({
      attr: 'dropoff.contact_phone_number';
    } & RoutesRouteTemplatesTripTemplatesPartialUpdateDropoffContactPhoneNumberErrorComponent)
  | ({
      attr: 'dropoff.driver_notes';
    } & RoutesRouteTemplatesTripTemplatesPartialUpdateDropoffDriverNotesErrorComponent)
  | ({
      attr: 'dropoff.place_id';
    } & RoutesRouteTemplatesTripTemplatesPartialUpdateDropoffPlaceIdErrorComponent)
  | ({
      attr: 'space_type';
    } & RoutesRouteTemplatesTripTemplatesPartialUpdateSpaceTypeErrorComponent)
  | ({
      attr: 'num_accompanying_passengers';
    } & RoutesRouteTemplatesTripTemplatesPartialUpdateNumAccompanyingPassengersErrorComponent);
export type RoutesRouteTemplatesTripTemplatesPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: RoutesRouteTemplatesTripTemplatesPartialUpdateError[];
};
export type RoutesRouteTemplatesTripTemplatesPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & RoutesRouteTemplatesTripTemplatesPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedRouteTripTemplate = {
  id?: string;
  passenger_id?: string;
  scheduled_pickup_time?: string;
  pickup?: TripLocationDetail;
  dropoff?: TripLocationDetail;
  /** The type of space in the vehicle this passenger will need */
  space_type?: SpaceTypeEnum;
  /** How many additional people will be accompanying the primary passenger */
  num_accompanying_passengers?: number;
};
export type PatchedRouteTripTemplateRead = {
  id?: string;
  route_template_id?: string;
  passenger_id?: string;
  scheduled_pickup_time?: string;
  pickup?: TripLocationDetailRead;
  dropoff?: TripLocationDetailRead;
  /** The type of space in the vehicle this passenger will need */
  space_type?: SpaceTypeEnum;
  /** How many additional people will be accompanying the primary passenger */
  num_accompanying_passengers?: number;
};
export type RoutesRouteTemplatesTripTemplatesDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type RouteRouteTemplate = {};
export type RouteRouteTemplateRead = {
  id: string;
  name: string;
};
export type Route = {
  route_template: RouteRouteTemplate;
};
export type RouteRead = {
  id: string;
  organization_id: string;
  route_template_id: string;
  route_template: RouteRouteTemplateRead;
  assignment_id: string;
  range_start: string;
  range_end: string;
  updated_at: string;
  created_at: string;
  deleted_at: string | null;
};
export type PaginatedRouteList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: Route[];
};
export type PaginatedRouteListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: RouteRead[];
};
export type RoutesRoutesListRangeStartErrorComponent = {
  attr: 'range_start';
  code: 'invalid';
  detail: string;
};
export type RoutesRoutesListRangeEndErrorComponent = {
  attr: 'range_end';
  code: 'invalid';
  detail: string;
};
export type RoutesRoutesListError =
  | ({
      attr: 'range_start';
    } & RoutesRoutesListRangeStartErrorComponent)
  | ({
      attr: 'range_end';
    } & RoutesRoutesListRangeEndErrorComponent);
export type RoutesRoutesListValidationError = {
  type: ValidationErrorEnum;
  errors: RoutesRoutesListError[];
};
export type RoutesRoutesListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & RoutesRoutesListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type RoutesRoutesRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export const {
  useRoutesRouteBambiRouteCreateMutation,
  useRoutesRouteTemplateDataListQuery,
  useLazyRoutesRouteTemplateDataListQuery,
  useRoutesRouteTemplateDataRetrieveQuery,
  useLazyRoutesRouteTemplateDataRetrieveQuery,
  useRoutesRouteTemplatesListQuery,
  useLazyRoutesRouteTemplatesListQuery,
  useRoutesRouteTemplatesCreateMutation,
  useRoutesRouteTemplatesRetrieveQuery,
  useLazyRoutesRouteTemplatesRetrieveQuery,
  useRoutesRouteTemplatesPartialUpdateMutation,
  useRoutesRouteTemplatesDestroyMutation,
  useRoutesRouteTemplatesMultiloadListQuery,
  useLazyRoutesRouteTemplatesMultiloadListQuery,
  useRoutesRouteTemplatesMultiloadCreateMutation,
  useRoutesRouteTemplatesMultiloadRetrieveQuery,
  useLazyRoutesRouteTemplatesMultiloadRetrieveQuery,
  useRoutesRouteTemplatesMultiloadPartialUpdateMutation,
  useRoutesRouteTemplatesMultiloadDestroyMutation,
  useRoutesRouteTemplatesTripTemplatesListQuery,
  useLazyRoutesRouteTemplatesTripTemplatesListQuery,
  useRoutesRouteTemplatesTripTemplatesCreateMutation,
  useRoutesRouteTemplatesTripTemplatesRetrieveQuery,
  useLazyRoutesRouteTemplatesTripTemplatesRetrieveQuery,
  useRoutesRouteTemplatesTripTemplatesPartialUpdateMutation,
  useRoutesRouteTemplatesTripTemplatesDestroyMutation,
  useRoutesRoutesListQuery,
  useLazyRoutesRoutesListQuery,
  useRoutesRoutesRetrieveQuery,
  useLazyRoutesRoutesRetrieveQuery,
} = injectedRtkApi;
